{
  "names": {
    "Fajr": "فجر",
    "Dhuhr": "ظهر",
    "Asr": "عصر",
    "Maghrib": "مغرب",
    "Isha": "عشا"
  },
  "card": {
    "label": "نماز بعدی",
    "labelTomorrow": "فردا · {{prayer}}",
    "inHoursMinutes": "تا {{hours}} ساعت و {{minutes}} دقیقه",
    "inMinutes": "تا {{minutes}} دقیقه",
    "open_aria": "باز کردن اوقات نماز",
    "pro": "Rhemn Pro",
    "unlock_aria": "اوقات نماز را با Rhemn Pro باز کنید",
    "unavailable": "اوقات نماز در حال حاضر در دسترس نیست."
  },
  "sheet": {
    "bellOn_aria": "خاموش کردن یادآور {{prayer}}",
    "bellOff_aria": "روشن کردن یادآور {{prayer}}",
    "explainer": "برای هر نماز یک یادآور ملایم دریافت کنید. یادآورها اعلان‌های بی‌صدا هستند — به‌طور پیش‌فرض بدون صدا.",
    "enableReminders": "فعال‌سازی یادآورها",
    "enableInSettings": "برای دریافت یادآور نماز، اعلان‌های Rhemn را در تنظیمات فعال کنید.",
    "openSettings": "باز کردن تنظیمات"
  },
  "notifications": {
    "body": "وقت نماز است."
  },
  "focus": {
    "label": "نماز {{prayer}}",
    "close_aria": "بستن صفحه نماز",
    "hint": "برای بازگشت Esc یا × را فشار دهید",
    "phrases": {
      "accepted": "خداوند نمازت را بپذیرد",
      "acceptedAr": "تقبّل الله صلاتك"
    }
  },
  "ambient": {
    "default": "با نیت آغاز کن. با برکت ادامه ده.",
    "prayerApproaches": "وقت نماز بعدی نزدیک می‌شود. در نیت خود استوار بمان.",
    "morningPursue": "صبحی پربرکت برای دنبال کردن: {{focus}}",
    "dayCloses": "با پایان روز، بر این تأمل کن: {{focus}}",
    "fulfilled": "امروز نیت خود را برآورده کردی. الحمدلله.",
    "workingTowards": "امروز در پی این هستی: {{focus}}",
    "prayerNear": "وقت نماز بعدی نزدیک است. نفسی تازه کن."
  },
  "widget": {
    "countdown": "{{time}} دیگر",
    "openToUpdate": "برای به‌روزرسانی Rhemn را باز کنید",
    "openForVerse": "برای آیهٔ امروز Rhemn را باز کنید"
  }
}
